import { SET_CAR_TYPE, SET_SELECTED_PACKAGE, SET_SERVICE_PACKAGE_STATE } from './constants';

export const setSelectedCar = (selectedCar) => ({
  type: SET_CAR_TYPE,
  payload: selectedCar,
});

export const setSelectedPackage = (selectedPackage) => ({
  type: SET_SELECTED_PACKAGE,
  payload: selectedPackage,
});

export const setServicePackageState = (payload: { field: string; value: any }) => ({
  type: SET_SERVICE_PACKAGE_STATE,
  payload,
});
